import { useContext } from "react";
import { ErrorContext } from "../contexts/ErrorContext";
import { IErrorContextType } from "../interfaces/IErrorContextType";

//This custom hook is responsible for consuming the error context.
export function useErrorContext(): IErrorContextType {
    const context = useContext(ErrorContext);
    
    if (!context) {
        throw new Error('The useErrorContext must be used within an ErrorProvider.');
    }

    return context;
}